// extracted by mini-css-extract-plugin
export default {"newCardForm":"AddCard_newCardForm__hwraa","addCardBtn":"AddCard_addCardBtn__gH3hi","error":"AddCard_error__CImv0"};